import React , { useState , useEffect , useContext } from "react";
import { Link , NavLink , useParams , useNavigate  } from "react-router-dom";
import  { WebAssetsContext }  from "../App";
const  Commodityordersview = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const params = useParams();
  const [disabled, setDisabled] = useState(false);
  const [id, setId] = useState(params.id);
  const [orderdetails, setOrderdetails] = useState(null);
  const getOrderDetails = async () => 
  {
    const res =  await fetch(api+"getOrder", {
            method: "POST",
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({id:id}),
          });
          let resJson = await res.json();
          return resJson;
  }

  const getOrder = async () => {
    try {
      const resJson = getOrderDetails();
      resJson.then(function(output) {
        if(output.status === true)
        {
          setOrderdetails(output.response)
        }
    });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getOrder();
  },[id])
  return (
    <>
      <div className="section-body">
                  <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Order Information</h4>
                                <div className="card-header-form">
                                      <button  onClick={() => navigate("/admin/commodity-orders")} className="btn btn-icon icon-left btn-primary"><i className="fas fa-arrow-right"></i> Back</button>
                                </div>
                            </div>
                            { orderdetails != null ? 
                            <div className="card-body p-4">
                            
                            <div className="row">
                                <div className="col-sm-4">
                                <h6>Ordered Details</h6>
                                   <div className="mb-4">
                                      <p className="m-0">Order ID : <b>#{orderdetails.id}</b></p>
                                      <p className="m-0" >Transaction ID : <b>#XXXXXXXXXX</b></p>
                                      <p className="m-0">Date : {props.changeDateFotmate(orderdetails.created_date , 'DD-MM-YYYY h:m:s a')}</p>
                                      
                                    
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                   <div className="mb-4">
                                   
                                      <p className="m-0" >CURRENCY  : {orderdetails.currency}</p>
                                      <p className="mb-2" >Order Type  :&nbsp;&nbsp;&nbsp;&nbsp;   

                                      { orderdetails.order_type == 'Sale' ?  <div className="badge badge-sm badge-danger">Sale</div> : ''}
                                      { orderdetails.order_type == 'Purchase' ?  <div className="badge badge-sm badge-success">Buy</div> : ''}
                                      </p>

                                      <p className="mb-2" >Deliverable Status  :&nbsp;&nbsp;&nbsp;&nbsp; 

                                      { orderdetails.deliverable_status == 'Delivery' ? <div className="badge badge-sm badge-dark">Delivery</div> : ''}
                                      { orderdetails.deliverable_status == 'Virtual' ? <div className="badge badge-sm badge-light">Virtual</div> : ''}
                                      </p>

                                      
                                      <p className="mb-2" >Status  :&nbsp;&nbsp;&nbsp;&nbsp;
                                      
                                      { orderdetails.order_status == 'Completed' ? <div className="badge badge-sm badge-success">Completed</div> : ''}
                                      { orderdetails.order_status == 'Pending' ? <div className="badge badge-sm badge-danger">Pending</div> : ''}
                                      { orderdetails.order_status == 'Cancelled' ? <div className="badge badge-sm badge-dark">Cancelled</div> : ''} 

                                        </p>
                                    
                                    </div>
                                </div>
                                <div className="col-sm-4">
                                <h6>Customer Details</h6>
                                <p className="m-0" >Customer  : {orderdetails.customer_name}</p>
                                <p className="m-0" >Email  : {orderdetails.customer_email}</p>
                                <p className="m-0" >Phone  : {orderdetails.customer_phone}</p>
                                </div>
                            </div>
                            
                              
                            <h6>Ordered Products</h6>
                            <table className="table table-sm table-bordered orderviewtble table-border">
                    
                                  <thead>
                                  <tr>
                                    <th scope="row">Product Name</th>
                                    <th scope="row">Product Quantity</th>
                                    <th scope="row">Product Price</th>
                                    <th scope="row">Total Price</th>
                                    
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr>
                                    
                                    <td>
                                      <p className="m-0">{orderdetails.product_name}</p>
                                      <p className="m-0"><small>{orderdetails.product_full_name}</small></p>

                                    </td>
                                    <td>{orderdetails.qty}</td>
                                    <td>{props.currencySymbol()}{orderdetails.amount}</td>
                                    <td>{props.currencySymbol()}{orderdetails.total_amount}</td>
                                  </tr>
                                  </tbody>
                                  
                                
                              </table>
                                 
                            </div>
                            : ''}
                        </div>
                      </div>
                  </div>
                  </div>
    </>

  );
}

export default Commodityordersview;
